export const STATE_NAME = 'dishes';

export const FETCH_DISHES = 'DISHES_FETCH_DISHES';
export const FETCH_DISHES_DONE = 'DISHES_FETCH_DISHES_DONE';
export const FETCH_DISHES_FAIL = 'DISHES_FETCH_DISHES_FAIL';

export const FETCH_EXCLUDED_DISHES = 'DISHES_FETCH_EXCLUDED_DISHES';
export const FETCH_EXCLUDED_DISHES_DONE = 'DISHES_FETCH_DISHES_EXCLUDED_DONE';
export const FETCH_EXCLUDED_DISHES_FAIL = 'DISHES_FETCH_DISHES_EXCLUDED_FAIL';

export const FETCH_DISH = 'DISHES_FETCH_DISH';
export const FETCH_DISH_DONE = 'DISHES_FETCH_DISH_DONE';
export const FETCH_DISH_FAIL = 'DISHES_FETCH_DISH_FAIL';

export const EXCLUDE_DISHES = 'DISHES_EXCLUDE_DISHES';
export const EXCLUDE_DISHES_DONE = 'DISHES_EXCLUDE_DISHES_DONE';
export const EXCLUDE_DISHES_FAIL = 'DISHES_EXCLUDE_DISHES_FAIL';

export const INCLUDE_DISHES = 'DISHES_INCLUDE_DISHES';
export const INCLUDE_DISHES_DONE = 'DISHES_INCLUDE_DISHES_DONE';
export const INCLUDE_DISHES_FAIL = 'DISHES_INCLUDE_DISHES_FAIL';
